import React, { useState } from 'react';
import { Users, Settings } from 'lucide-react';
import Employees from './Employees';
import SettingsPanel from '../components/SettingsPanel';

type AdminTab = 'employees' | 'settings';

const Administration: React.FC = () => {
  const [activeTab, setActiveTab] = useState<AdminTab>('employees');

  const tabs = [
    { key: 'employees' as const, label: 'Employees', icon: Users },
    { key: 'settings' as const, label: 'Settings', icon: Settings },
  ];

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto">
      <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
        <nav className="flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-2 py-3 px-1 border-b-2 text-sm font-medium transition-colors ${
                activeTab === tab.key
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400'
              }`}
            >
              <tab.icon className="h-4 w-4" />
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'employees' && <Employees />}
      {activeTab === 'settings' && <SettingsPanel />}
    </div>
  );
};

export default Administration;
